import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER} from '@angular/cdk/keycodes';

@Component({
  selector: 'app-dialog-share-email',
  templateUrl: './dialog-share-email.component.html',
  styleUrls: ['./dialog-share-email.component.scss'],
})
export class DialogShareEmailComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;

  claimID;
  beneficiaryID;
  mailDetail = {
    email: '',
    subject: '',
    body: '',
  };

  addOnBlur = true;
  myEmail: any = [];
  mailData: any = [];
  removable: boolean = true;
  selectable: boolean = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  constructor(
    public dialogRef: MatDialogRef<DialogShareEmailComponent>,

    private commonService: CommonService,
    public dialog: MatDialog,
    private ativateRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    if (this.data.typeShare == 'BeneficiaryRequirement') {
      this.claimID = this.data.claimID;
      this.beneficiaryID = this.data.beneficiaryID;
    }
  }

  addToMail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add Mail Id
    if (value) {
      this.mailData.push(value);
    }
    // Clear Input Value
    if (event.input) {
      event.input.value = '';
    }
  }

  removeToMail(mail): void {
    const index = this.mailData.indexOf(mail);
    if (index >= 0) {
      this.mailData.splice(index, 1);
    }
  }

  onChangeValue(event, key) {
    if (key == 'body') {
      this.mailDetail[key] = event.value;
    } else {
      this.mailDetail[key] = event;
    }
  }

  async onSend() {
    let temp = '';
    for (let i = 0; i < this.mailData.length; i++) {
      temp = temp + this.mailData[i];
      if (i + 1 != this.mailData.length) temp = temp + ',';
    }
    this.mailDetail.email = temp;
    if (this.data.typeShare == 'BeneficiaryRequirement') {
      this.sendBeneficiaryRequirementMail();
    }
  }

  //Post API - Sending Mail for Beneficiary Requirement.
  async sendBeneficiaryRequirementMail() {
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimID +
        '/beneficiary/' +
        this.beneficiaryID +
        '/sendEmail';
      await this.commonService.commonPost(url, this.mailDetail);
      console.log('reponse');
      this.onClose();
    } catch (err) {
      console.log(
        'Post API - Sending Mail for Beneficiary Requirement Error.',
        err
      );
    }
  }
  onCancel() {
    this.onClose();
  }

  onClose() {
    this.dialogRef.close(false);
  }
}
